module.exports = {
  title: 'Drag to Sort with Reanimated and Gesture Handler 🤌🏽',
  author: 'Enzo Manuel Mangano',
  date: '2023-12-20',
  slug: 'drag-to-sort',
  tags: ['reanimated', 'gesture-handler'],
};
